import { createEventService } from "../infrastructure/services/createEventService";
import { CheckInGuestRequest, CreateEventRequest, EventActions } from "../domain/events";
import { checkInGuestService } from "../infrastructure/services/checkInGuestService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const checkInGuest = {
    async execute(
        clientCode: string,
        documentType: string,
        document: string
    ): Promise<void> {
        const request: CheckInGuestRequest = await EventActions().checkInGuestRequest(
            clientCode,
            documentType,
            document
        );
        await checkInGuestService.execute(await tokenValidation.execute(), request);
    },
};


